import { Alert, Button, Text, Card, Image, CardColors, Icon } from '@/ui'
import {
  FinancialAdvisoryProfile,
  FinancialAdvisoryProfilesStatus,
  putFinancialAdvisoryProfile,
} from '../financialAdvisory.slice'
import { useEffect, useState } from 'react'
import { track } from '@amplitude/analytics-browser'
import { useAnalyticsView } from '@/features/amplitude'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

export const PlanCompletedPanel = ({
  faProfile,
}: {
  faProfile: FinancialAdvisoryProfile
}) => {
  const dispatch = useAppDispatch()
  const pageView = useAnalyticsView()
  const [error, setError] = useState('')

  // This officially enables the user to start onboarding to Uprise
  const viewUprisePlan = async () => {
    setError('')
    track('viewed uprise plan', {
      fa_profile_id: faProfile.id,
      user_id: faProfile.userId,
    })
    // Set profile to active
    await putFinancialAdvisoryProfile(faProfile.id, {
      status: FinancialAdvisoryProfilesStatus.active,
    })(dispatch)
  }

  useEffect(() => {
    pageView('advisory: viewed plan completed panel')
  }, [pageView])

  return (
    <>
      {error && (
        <Alert
          variant="error"
          description="It looks like we encountered an error while trying to onboard you! Please try again."
        />
      )}

      <Card color={CardColors.LEVEL_0}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="w-full lg:w-5/12 flex justify-center">
              <Image
                src="https://heard-images.s3.amazonaws.com/assets/celebration.svg"
                alt="heard financial advisory"
                width="300"
              />
            </div>
            <div className="w-full lg:w-7/12 space-y-4">
              <Text variant={TypographyStyles.H2}>
                Your Financial Plan is ready!
              </Text>
              <Text variant={TypographyStyles.BODY_MD}>
                We’re so excited to share your personalized financial plan,
                crafted with your financial goals in mind, alongside your
                financial advisor.
              </Text>
              <Text variant={TypographyStyles.H3}>
                With this financial plan, you can:
              </Text>
              <div className="space-y-2">
                <Text variant={TypographyStyles.BODY_MD}>
                  <Icon
                    icon={regular('check')}
                    color="text-moss-600"
                    className="mr-2 inline-block"
                  />
                  Review recommendations provided by your advisor
                </Text>
                <Text variant={TypographyStyles.BODY_MD}>
                  <Icon
                    icon={regular('check')}
                    color="text-forest"
                    className="mr-2 inline-block"
                  />
                  Message asynchronously with your advisor
                </Text>
                <Text variant={TypographyStyles.BODY_MD}>
                  <Icon
                    icon={regular('check')}
                    color="text-forest"
                    className="mr-2 inline-block"
                  />
                  Schedule 1:1 video calls for an additional fee
                </Text>
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-8">
            <div className="w-full lg:w-7/12">
              <Button
                variant="primary"
                className="w-full"
                onClick={viewUprisePlan}
              >
                View your Financial Plan
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </>
  )
}
